export interface ILoadingState {
  hidden: boolean;
}

export const initialLoadingState: ILoadingState = {
  hidden: true,
};
